import { CEMediaBase } from './ce-media-base'


export class CEMedia extends CEMediaBase {

}